export function filterEducationalContent(data, userConditions) {
    if (!Array.isArray(userConditions) || userConditions.length === 0) return [];

    return data.filter(content => {
        const tagsLower = content.tags.map(t => t.toLowerCase());
        return tagsLower.some(tag =>
            userConditions.some(cond => cond.includes(tag) || tag.includes(cond))
        );
    });
}
